import { ContentType } from "@redotech/redo-support-conversation-protocol-common/conversation-protocol";
import { literal, object, string } from "zod";
import {
  AutoGeneratedFieldsSchema,
  BaseActionableContentMessageSchema,
} from "../message-parser-utils";

//TODO: I think we can remove this when we purge old concierge code
/**
 * @deprecated Display order tracking info UI component removed on 01/22/2025.
 * Deprecated in favor of TrackOrderUiMessageSchema.
 */
export const DisplayOrderTrackingInfoMessageSchema =
  BaseActionableContentMessageSchema.extend({
    contentType: literal(ContentType.DISPLAY_ORDER_TRACKING_INFO),
    structuredContent: object({
      orderId: string(),
      email: string(),
    }).optional(),
  });

/*
 * @deprecated Display order tracking info UI component removed on 01/22/2025.
 * Deprecated in favor of TrackOrderUiMessageSchema.
 */
export const DisplayOrderTrackingInfoMessageDbParser =
  DisplayOrderTrackingInfoMessageSchema.merge(AutoGeneratedFieldsSchema);
